import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { createStyles, alpha, makeStyles, Theme } from '@material-ui/core/styles';
import { FiLock } from 'react-icons/fi';

import { NO_MODULE_ACCESS_TEXT } from '../constants';

const useStyles = makeStyles((theme: Theme) => {
  const dark = theme.palette.type === 'dark';
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: theme.spacing(8, 3),
    },
    iconWrap: {
      width: 64,
      height: 64,
      borderRadius: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, dark ? 0.2 : 0.14),
      marginBottom: theme.spacing(2),
    },
    subtitle: {
      marginTop: theme.spacing(1),
      maxWidth: 420,
    },
  });
});

interface Props {
  title?: string;
  subtitle?: string;
}

/**
 * Shown in place of a screen the user has no permission for. Prefer this to a
 * bare `null` — an empty page reads as a bug, not as a missing right.
 */
export const NoAccess: React.FC<Props> = ({
  title = 'You don’t have access to this',
  subtitle = NO_MODULE_ACCESS_TEXT,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <div className={classes.iconWrap}>
        <FiLock size={26} />
      </div>

      <Typography variant="h6">{title}</Typography>

      <Typography variant="body2" color="textSecondary" className={classes.subtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};
